import { AnyAction } from 'redux';
import {
  GlobalActions,
  isMaklerbetreuerOrMaklerOrUvm,
  ZahlungsoptionenChanged,
} from '@ps20-frontend/shop-integration-redux';
import cloneDeep from 'lodash/cloneDeep';
import { Vertreter as VermittlerBff, Zahlungsart } from '@ps20/bff-models';
import { Zahlungsoptionen } from '../interfaces/zahlungsoptionen';

export const zahlungsoptionenReducer = function (
  sectionState: Zahlungsoptionen = null,
  action: AnyAction,
): Zahlungsoptionen {
  switch (action.type) {
    case GlobalActions.ZAHLUNGSOPTIONEN_CHANGED:
    case GlobalActions.ZAHLUNGSOPTIONEN_CHANGED_VORVERTRAG: {
      const newState: Zahlungsoptionen = cloneDeep(sectionState);
      const zahlungsoptionen: ZahlungsoptionenChanged = action.payload;
      if (zahlungsoptionen) {
        newState.zahlungsweise = zahlungsoptionen.zahlungsweise
          ? zahlungsoptionen.zahlungsweise
          : newState.zahlungsweise;
        newState.zahlungsart = zahlungsoptionen.zahlungsart
          ? zahlungsoptionen.zahlungsart
          : newState.zahlungsart;
      }
      return newState;
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      const vertreter = action.payload.vertreter as VermittlerBff;
      if (vertreter.isInkasso && isMaklerbetreuerOrMaklerOrUvm(vertreter.role)) {
        return {
          ...sectionState,
          zahlungsart: Zahlungsart.MAKLER_INKASSO,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
